<template>
    <div class="html-input">
        <label :for="name">{{ label }}</label>
        
        <textarea
            type="text"
            :name="name"
            v-model="input"
            cols="10"
            :rows="rows"
        ></textarea>

        <div
            v-if="error"
            class="html-input__error"
        >
            {{ errorText }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
            default: 'label'
        },
        name: {
            type: String,
            required: true,
            default: 'name'
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        errorText: {
            type: String,
            required: true,
            default: 'name'
        },
        rows: {
            type: Number,
            required: false,
            default: null
        }
    },
    data() {
        return {
            input: undefined
        }
    },
    watch: {
        input() {
            this.$emit('clearError', this.name);
            this.$emit('set', this.name, this.input);
        }
    }
}
</script>
